//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { OpFile } from "../core/op-file";
import { Enums } from "../common/enums"
import { OpDeviceType } from '../core/op-device-type'
import { DataProvider } from '../../helpers/data-provider'
import { TypeHelper } from '../../helpers/type-helper'
import { Dictionary } from '../../helpers/dictionary'
import { LocalizationHelper } from '../../helpers/localization-helper'

export class DeviceConnectionMarkerIcon {
    public state: Enums.DeviceConnectionMarkerState
    public icon: OpFile
    public idDeviceType: number[]

    public deviceType: OpDeviceType[]

    constructor(opObject: any = null) {
        if (opObject) {
            this.state = opObject.State
            this.icon = new OpFile(opObject.Icon)
            this.idDeviceType = opObject.IdDeviceType.map(x => +x)
        }
    }

    public toString() {
        let result: string = TypeHelper.emptyString

        if (this.state === Enums.DeviceConnectionMarkerState.NotRetransmitted) {
            result += LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NotRetransmitted)
        } else if (this.state === Enums.DeviceConnectionMarkerState.Retransmitted) {
            result += LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Retransmitted)
        } else {
            result += LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Unknown)
        }

        return result;
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: DeviceConnectionMarkerIcon[]): JQueryPromise<DeviceConnectionMarkerIcon[]> {
        const defered = $.Deferred<DeviceConnectionMarkerIcon[]>()

        if (dataProvider && list && list.length > 0) {
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDeviceType]).then(dict => {
                let dataTypeDict: Dictionary<OpDeviceType> = new Dictionary<OpDeviceType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDeviceType)) {
                    dataTypeDict = <Dictionary<OpDeviceType>>dict.tryGetValue(Enums.ReferenceType.IdDeviceType)
                }

                list.forEach(item => {
                    item.deviceType = []
                    if (item.idDeviceType && item.idDeviceType.length > 0) {
                        item.idDeviceType.forEach(id => {
                            const deviceType = dataTypeDict.tryGetValue(id)
                            if (deviceType)
                                item.deviceType.push(deviceType)
                        })
                    }
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }
}